module.exports = __webpack_public_path__ + "assets/img/icon12-menu2.e1135ce9.svg";